exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".minimum-order .pr_plus_first svg{width:45px!important}.minimum-order .addto_cart_in svg{width:22px!important}@media (max-width:767px){.minimum-order ul.slick-dots{bottom:-38px}}", ""]);

// exports
